var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotationLock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.241 14.25H11.25M6.25 14.25H6.25897",
    stroke: "#E48A1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01781 17.5947C1.24269 19.265 2.62613 20.5735 4.30966 20.6509C5.72627 20.716 7.1653 20.75 8.75 20.75C10.3347 20.75 11.7737 20.716 13.1903 20.6509C14.8739 20.5735 16.2573 19.265 16.4822 17.5947C16.629 16.5047 16.75 15.3876 16.75 14.25C16.75 13.1124 16.629 11.9953 16.4822 10.9053C16.2573 9.23502 14.8739 7.92649 13.1903 7.84909C11.7737 7.78397 10.3347 7.75 8.75 7.75C7.1653 7.75 5.72627 7.78397 4.30966 7.84909C2.62613 7.92649 1.24269 9.23502 1.01781 10.9053C0.871046 11.9953 0.75 13.1124 0.75 14.25C0.75 15.3876 0.871046 16.5047 1.01781 17.5947Z",
    stroke: "#E48A1D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7.75V5.25C4.25 2.76472 6.26472 0.75 8.75 0.75C11.2353 0.75 13.25 2.76472 13.25 5.25V7.75",
    stroke: "#E48A1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotationLock2);
export default __webpack_public_path__ + "static/media/rotation-lock-2.4baba9916d765f48d6c36f7a81da2821.svg";
export { ForwardRef as ReactComponent };